// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiurl: "https://dev-trakly-api.dooya.co.za/",
  weburl: "https://dev-legacy-admin.dooya.co.za/",
  reCaptchaKey: "6LecEMgcAAAAAEzull92aQ7sEsZHqNjl6bn_UZ2F",
  appVersion: require('../../package.json').version + ' (Development)',
  /** Dev/local only: Tools page manual job triggers (Process Trades, Prebooking, Bank Balances). */
  showRunJobsTools: true,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
